import {createAction} from '@reduxjs/toolkit';
import {type GeoJsonObject} from 'geojson';

const actionPrefix = 'SEARCH';

export const setDateRanges = createAction(`${actionPrefix}/SET_DATE_RANGES`);

export const resetDateRanges = createAction(
  `${actionPrefix}/RESET_DATE_RANGES`,
);

type SaveGeometryProps = {
  featureReference?: string;
  geometry?: GeoJsonObject;
  geometryTooLarge?: boolean;
  geometryZoomTo?: boolean;
  isGeometryTooComplex?: boolean;
  name?: string;
  zoomTo?: boolean;
};

export const saveGeometry = createAction<SaveGeometryProps>(
  `${actionPrefix}/SAVE_GEOMETRY`,
);

export const continueSearch = createAction(`${actionPrefix}/CONTINUE_SEARCH`);

export const clearSearch = createAction(`${actionPrefix}/CLEAR_SEARCH`);

export const toggleNoEndDate = createAction(
  `${actionPrefix}/TOGGLE_NO_END_DATE`,
);

export const loadSearch = createAction(`${actionPrefix}/LOAD_SEARCH`);

export const searchSingleItem = createAction(
  `${actionPrefix}/SEARCH_SINGLE_ITEM`,
);

export const resetSearchPageNumber = createAction(
  `${actionPrefix}/RESET_SEARCH_PAGE_NUMBER`,
);
